// 사이트탐색알림(중고거래) 관련 API 함수 (tb_marketplace_watch, tb_marketplace_alert_history)
import axiosInstance from './axiosInstance';

// 감시조건 목록 조회
export const fetchWatches = async () => {
  const response = await axiosInstance.get('/marketplace/watch');
  return response.data.data;
};

// 감시조건 등록
export const createWatch = async (payload) => {
  const response = await axiosInstance.post('/marketplace/watch', payload);
  return response.data;
};

// 감시조건 수정
export const updateWatch = async (id, payload) => {
  const response = await axiosInstance.put(`/marketplace/watch/${id}`, payload);
  return response.data;
};

// 감시조건 삭제
export const deleteWatch = async (id) => {
  const response = await axiosInstance.delete(`/marketplace/watch/${id}`);
  return response.data;
};

// 알림 발송 이력 조회 (페이징)
export const fetchAlertHistory = async (page = 1, limit = 20) => {
  const response = await axiosInstance.get('/marketplace/alert-history', {
    params: { page, limit },
  });
  return response.data;
};

// 조용한 시간(발송 금지 시간대) 설정 조회
export const fetchMarketplaceSettings = async () => {
  const response = await axiosInstance.get('/marketplace/settings');
  return response.data;
};

// 조용한 시간(발송 금지 시간대) 설정 저장
export const updateMarketplaceSettings = async (payload) => {
  const response = await axiosInstance.put('/marketplace/settings', payload);
  return response.data;
};
